import { Modal } from "react-bootstrap";
import Select from "react-select";
import { PlatformType } from "../../../configs";
import {DialPadKeyMappingModel, DialPapType, Option, unknownDialPad} from "../../../models";
import {FormErrorMessage} from "../../../components";
import React, {useEffect, useRef, useState} from "react";
type Props = {
  isAudioForLanguageMappingEnabled: boolean;
  onLanguageAudioMappingToggle: () => void;
  show: boolean;
  handleShow: (value: boolean) => void;
  header: string;
  totalDialPadNumber: number;
  dialPadDropdownList: Option[];
  onSaveHandler: any;
  showZeroEnabledToPinInput: boolean;
  showZeroEnabledForOperatorLanguageRouting: boolean;
  operatorLanguageOptions: Option[];
  operatorRoutingLanguageId?: string | null;
  operRoutingLanguageFailure?: boolean;
  operRoutingLanguageFailureLanguageId?: string | null;
  showEnableToggler: boolean;
  isZeroEnabledToPinInput: boolean;
  isZeroEnabledForOperatorLanguageRouting: boolean;
  isEnabled: boolean;
  dialMapType: PlatformType;
  onDialKeyDropDownChangeHandle: any;
  dialPadKeyMappingModels: DialPadKeyMappingModel[];
  onZeroEnableToggleHandler: any;
  onZeroOperatorLanguageRoutingToggleHandler: any;
  onEnabledToggleHandler: any;
};

let errorMapping = new Map();
let selectedDialPadKey: DialPadKeyMappingModel[] = [];

const togglePanelStyle: React.CSSProperties = {
  color: "var(--text)",
  background: "linear-gradient(135deg, rgba(70, 120, 160, 0.10), rgba(70, 120, 160, 0.025))",
  borderRadius: "10px",
};

export function ModalIvrDialKeyMapping(props: Props) {

  const { show, handleShow, header, totalDialPadNumber, dialPadDropdownList, onSaveHandler, onDialKeyDropDownChangeHandle, 
    showEnableToggler, showZeroEnabledToPinInput, showZeroEnabledForOperatorLanguageRouting, isEnabled, isZeroEnabledToPinInput,
    isZeroEnabledForOperatorLanguageRouting, dialMapType, dialPadKeyMappingModels, onZeroEnableToggleHandler,
    onZeroOperatorLanguageRoutingToggleHandler, onEnabledToggleHandler, operatorLanguageOptions, operatorRoutingLanguageId} = props;

  const [operatorRoutingLanguage, setOperatorRoutingLanguage] = useState<Option | null>(null);
  const [operatorRoutingLanguageError, setOperatorRoutingLanguageError] = useState(false);
  const [languageFailureEnabled, setLanguageFailureEnabled] = useState(props.operRoutingLanguageFailure ?? false);
  const [languageFailureLanguageId, setLanguageFailureLanguageId] = useState(
    props.operRoutingLanguageFailure ? props.operRoutingLanguageFailureLanguageId ?? null : null
  );
  const [languageFailureError, setLanguageFailureError] = useState(false);
  const [isSaving, setIsSaving] = useState(false);
  const savingRef = useRef(false);
  const { isAudioForLanguageMappingEnabled, onLanguageAudioMappingToggle } = props;
  const operatorRoutingLanguageSectionRef = useRef<HTMLDivElement>(null);
  const wasOperatorRoutingEnabled = useRef(isZeroEnabledForOperatorLanguageRouting);

  useEffect(() => {
    setOperatorRoutingLanguage(
      operatorLanguageOptions.find(
        (language) => language.value.toString() === operatorRoutingLanguageId
      ) ?? null
    );
  }, [operatorLanguageOptions, operatorRoutingLanguageId]);

  useEffect(() => {
    if (!isZeroEnabledForOperatorLanguageRouting) {
      setOperatorRoutingLanguageError(false);
    }
  }, [isZeroEnabledForOperatorLanguageRouting]);

  useEffect(() => {
    const wasEnabled = wasOperatorRoutingEnabled.current;
    wasOperatorRoutingEnabled.current = isZeroEnabledForOperatorLanguageRouting;

    if (isZeroEnabledForOperatorLanguageRouting && !wasEnabled) {
      const scrollTimeout = window.setTimeout(() => {
        operatorRoutingLanguageSectionRef.current?.scrollIntoView({
          behavior: 'smooth',
          block: 'nearest',
        });
      }, 0);
      return () => window.clearTimeout(scrollTimeout);
    }
  }, [isZeroEnabledForOperatorLanguageRouting]);

  let remainingDropDownList: Option[] = [];
  const isLanguageMapping = Number(dialMapType) === DialPapType.language;
  const useDialPadGrid = isLanguageMapping || Number(dialMapType) === DialPapType.skill;

  const dropDownDefaultValue = (dialPadNumber: string) => {
    const isExist = dialPadKeyMappingModels?.find(x => x.key === dialPadNumber);
    const ignoreDropDownListName = dialPadKeyMappingModels.map(x => x.name);
    remainingDropDownList = dialPadDropdownList?.filter(x => !(ignoreDropDownListName.includes(x.label)));
    return isExist?.value !== unknownDialPad.value ? dialPadDropdownList?.find(x => x.value.toString() === isExist?.value.toString()) : null;
  };

  const clearStates = () => {
    selectedDialPadKey = [];
    errorMapping.clear();
  }

  const checkWhichDialPadIsSelected = (dialPad: string) => {
    const isExist = dialPadKeyMappingModels?.find(x => x.key === dialPad);

    if(isExist) {
      selectedDialPadKey = [
        ...selectedDialPadKey,
        {
          key: dialPad,
          name: isExist?.name,
          value: isExist?.value?.toString()
        }
      ];
    }
  }

  useEffect(() => {
    clearStates();
    for(let i=0; i<totalDialPadNumber; i++) {
      checkWhichDialPadIsSelected((i + 1).toString());
    }
  }, [dialPadKeyMappingModels]);

  const filterAndAdd = (option: Option, dialPadNumber: string) => {
    const alreadyOccurred = selectedDialPadKey?.find(data => data?.key === dialPadNumber);
    selectedDialPadKey = alreadyOccurred ? selectedDialPadKey?.filter(data => data?.key !== dialPadNumber) : selectedDialPadKey;
    selectedDialPadKey = [
      ...selectedDialPadKey,
      {
        key: dialPadNumber,
        name: option?.label,
        value: option?.value?.toString()
      }
    ];
  }

  const checkDuplicates = () => {
    const allValues = selectedDialPadKey.map(item => item?.value);

    for(let value of allValues) {
      if(value !== "") {
        const filtered = selectedDialPadKey?.filter(data => data?.value === value) || [];
        if(filtered?.length > 1) {
          filtered?.map(data => errorMapping.set(data?.key, 'Duplicate'));
        } else {
          errorMapping.set(filtered[0]?.key, '');
        }
      }
    }
  }

  const handleOptionChange = (option: any, dialPadNumber: string) => {
    filterAndAdd(option, dialPadNumber);
    checkDuplicates();
  }

  const hasDuplicateValue = () => {
    const errors = Array.from(errorMapping.values());
    return errors.includes('Duplicate');
  }

  return (
    <Modal
      show={show}
      onHide={() => {
        if (savingRef.current) return;
        clearStates();
        handleShow(false);
      }}
      centered
      scrollable
    >

              {/*@ts-ignore */}
        <Modal.Header closeButton>
        <Modal.Title>{header}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <fieldset disabled={isSaving}>
        {showEnableToggler ? <div className="d-flex flex-wrap pb-4 justify-content-between align-items-center">
            <div className="col px-0">
              <div>Enable {header?.replace('IVR','')}</div>
            </div>
            <div className="px-3 mr-3">
              <button
                type="button"
                // data-toggle="button"
                className={isEnabled ? `btn btn-toggle text-right on-off-btn active` : `btn btn-toggle text-right on-off-btn`}
                onClick={() => { onEnabledToggleHandler(isEnabled) }}
              >
                <div className="handle"></div>
              </button>
            </div>
          </div> : null
        }

        <div className={useDialPadGrid ? "row mx-n2" : undefined}>
        {
          Array.from({ length: totalDialPadNumber }, (_, i) => (
            <div className={useDialPadGrid ? "form-group col-6 px-2" : "form-group row align-items-center"} key={i}>
              <label
                htmlFor={`dial-pad-${dialMapType}-${i + 1}`}
                className={useDialPadGrid ? "text-muted d-block mb-1" : "col-12 col-sm-4 text-muted d-block mb-0"}
              >
                Dial Pad {i + 1}
              </label>
              <div className={useDialPadGrid ? "text-muted" : "col-12 col-sm-8 text-muted"}>
                <Select
                  inputId={`dial-pad-${dialMapType}-${i + 1}`}
                  isDisabled={isSaving}
                  className={` ${ errorMapping.get((i+1).toString()) === "Duplicate" ? 'field-required' : ''} `}
                  components={{
                    IndicatorSeparator: () => null,
                  }}
                  defaultValue={dropDownDefaultValue((i + 1).toString())}
                  placeholder={useDialPadGrid ? `Select ${DialPapType[dialMapType]}` : `Select a dial pad ${DialPapType[dialMapType]}`}
                  options={dialPadDropdownList}
                  onChange={(option) => {
                    onDialKeyDropDownChangeHandle(option, i + 1);
                    handleOptionChange(option, (i+1).toString());
                  }}
                />
                {
                  errorMapping.get((i+1).toString()) && <FormErrorMessage message="*Duplicate" />
                }
              </div>
            </div>
          ))
        }
        </div>

        {isLanguageMapping && (
          <div className="d-flex flex-wrap justify-content-between align-items-center mt-3 p-3" style={togglePanelStyle}>
            <div className="col px-0" id="audio-for-language-mapping-label">
              Enable manual text/audio for language mapping
            </div>
            <div className="px-3">
              <button
                type="button"
                role="switch"
                aria-checked={isAudioForLanguageMappingEnabled}
                aria-labelledby="audio-for-language-mapping-label"
                className={isAudioForLanguageMappingEnabled ? 'btn btn-toggle text-right on-off-btn active' : 'btn btn-toggle text-right on-off-btn'}
                onClick={onLanguageAudioMappingToggle}
              >
                <div className="handle"></div>
              </button>
            </div>
          </div>
        )}

        {isLanguageMapping && (
          <div className="p-3 mt-3" style={togglePanelStyle}>
            <div className="d-flex flex-wrap justify-content-between align-items-center">
              <div className="col px-0" id="operator-routing-language-failure-label">
                Operator routing language failure
              </div>
              <div className="px-3">
                <button
                  type="button"
                  role="switch"
                  aria-checked={languageFailureEnabled}
                  aria-labelledby="operator-routing-language-failure-label"
                  className={`btn btn-toggle text-right on-off-btn${languageFailureEnabled ? ' active' : ''}`}
                  onClick={() => {
                    setLanguageFailureEnabled(!languageFailureEnabled);
                    if (languageFailureEnabled) setLanguageFailureLanguageId(null);
                    setLanguageFailureError(false);
                  }}
                >
                  <div className="handle" />
                </button>
              </div>
            </div>
            {languageFailureEnabled && (
              <div className="mt-2 pt-2">
                <label htmlFor="operator-routing-language-failure-language">Please select a language:</label>
                <Select
                  inputId="operator-routing-language-failure-language"
                  components={{ IndicatorSeparator: () => null }}
                  options={operatorLanguageOptions}
                  placeholder="Select a language"
                  value={operatorLanguageOptions.find((option) => option.value === languageFailureLanguageId) ?? null}
                  isDisabled={isSaving}
                  className={languageFailureError ? 'field-required' : ''}
                  aria-invalid={languageFailureError}
                  onChange={(option) => {
                    setLanguageFailureLanguageId(option?.value ?? null);
                    setLanguageFailureError(false);
                  }}
                />
                {languageFailureError && (
                  <FormErrorMessage message="Please select a language for operator routing language failure." />
                )}
              </div>
            )}
          </div>
        )}

        {showZeroEnabledForOperatorLanguageRouting ? <div className="p-3 mt-3" style={togglePanelStyle}>
          <div className="d-flex flex-wrap justify-content-between align-items-center">
            <div className="col px-0">
              <div>Enable "0" for pin input</div>
            </div>
            <div className="px-3">
              <button
                type="button"
                className={isZeroEnabledToPinInput ? `btn btn-toggle text-right on-off-btn active` : `btn btn-toggle text-right on-off-btn`}
                disabled={isZeroEnabledForOperatorLanguageRouting}
                title={isZeroEnabledForOperatorLanguageRouting ? 'Disable operator language routing to enable pin input' : undefined}
                onClick={() => { onZeroEnableToggleHandler(isZeroEnabledToPinInput) }}
              >
                <div className="handle"></div>
              </button>
            </div>
          </div>
          <div className="mt-3 pt-3">
            <div className="d-flex flex-wrap justify-content-between align-items-center">
              <div className="col px-0">
                <div>Enable "0" for operator language routing</div>
              </div>
              <div className="px-3">
                <button
                  type="button"
                  className={isZeroEnabledForOperatorLanguageRouting ? `btn btn-toggle text-right on-off-btn active` : `btn btn-toggle text-right on-off-btn`}
                  disabled={isZeroEnabledToPinInput}
                  title={isZeroEnabledToPinInput ? 'Disable pin input to enable operator language routing' : undefined}
                  onClick={onZeroOperatorLanguageRoutingToggleHandler}
                >
                  <div className="handle"></div>
                </button>
              </div>
            </div>
            {isZeroEnabledForOperatorLanguageRouting ? <div ref={operatorRoutingLanguageSectionRef} className="mt-2 pt-2">
              <label htmlFor="operator-routing-language">Please select a language:</label>
              <Select
                inputId="operator-routing-language"
                isDisabled={isSaving}
                className={operatorRoutingLanguageError ? 'field-required' : ''}
                components={{ IndicatorSeparator: () => null }}
                options={operatorLanguageOptions}
                placeholder="Select a language"
                value={operatorRoutingLanguage}
                onChange={(option) => {
                  setOperatorRoutingLanguage(option as Option | null);
                  setOperatorRoutingLanguageError(false);
                }}
              />
              {operatorRoutingLanguageError && (
                <FormErrorMessage message="Please select a language for operator language routing." />
              )}
            </div> : null}
          </div>
        </div> : showZeroEnabledToPinInput ? <div className="d-flex flex-wrap justify-content-between align-items-center pt-1">
          <div className="col px-0">
            <div>Enable "0" for pin input</div>
          </div>
          <div className="px-3 mr-3">
            <button
              type="button"
              className={isZeroEnabledToPinInput ? `btn btn-toggle text-right on-off-btn active` : `btn btn-toggle text-right on-off-btn`}
              onClick={() => { onZeroEnableToggleHandler(isZeroEnabledToPinInput) }}
            >
              <div className="handle"></div>
            </button>
          </div>
        </div> : null}
        </fieldset>
      </Modal.Body>
      <Modal.Footer>
        <button
          type="button"
          className="btn btn-link text-site text-uppercase"
          disabled={isSaving}
          onClick={() => {
            clearStates();
            handleShow(false);
          }}
        >
          Cancel
        </button>
        <button type="button" className="btn btn-primary login-from-submit-btn text-uppercase"
                onClick={async () => {
                  if (savingRef.current) return;
                  const operatorRoutingLanguageId = isZeroEnabledForOperatorLanguageRouting
                    ? operatorRoutingLanguage?.value?.toString()
                    : undefined;

                  if (isZeroEnabledForOperatorLanguageRouting && !operatorRoutingLanguageId) {
                    setOperatorRoutingLanguageError(true);
                    return;
                  }

                  if (isLanguageMapping && languageFailureEnabled && !operatorLanguageOptions.some(
                    (option) => option.value === languageFailureLanguageId
                  )) {
                    setLanguageFailureError(true);
                    return;
                  }
                  savingRef.current = true;
                  setIsSaving(true);
                  try {
                    await onSaveHandler(
                      dialMapType,
                      operatorRoutingLanguageId,
                      isLanguageMapping ? {
                        operRoutingLanguageFailure: languageFailureEnabled,
                        operRoutingLanguageFailureLanguageId: languageFailureEnabled ? languageFailureLanguageId : null,
                      } : undefined
                    );
                  } finally {
                    savingRef.current = false;
                    setIsSaving(false);
                  }
                }}
                disabled={isSaving || hasDuplicateValue()}
        >
          {isSaving ? 'Saving...' : 'Save'}
        </button>
      </Modal.Footer>

    </Modal>
  );
}
